import Calculator from './views/calculator.c';
export default Calculator;
